import { useId, useState } from "react";

/**
 * "?" help button for form labels in the scheduling create/edit modals.
 * Click toggles the message; it hides when the button loses focus or on Escape.
 * Props:
 *   label    — accessible name for the button (e.g. "Capacity help")
 *   message  — help text shown in the bubble
 */
const HintTooltip = ({ label, message }) => {
  const [open, setOpen] = useState(false);
  const tooltipId = useId();

  return (
    // Rendered inside <label>: swallow clicks so they don't focus the field.
    // biome-ignore lint/a11y/noStaticElementInteractions: click guard only
    // biome-ignore lint/a11y/useKeyWithClickEvents: click guard only
    <span
      className="create-class-modal-hint"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <button
        type="button"
        className="create-class-modal-hint-btn"
        aria-label={label}
        aria-expanded={open}
        aria-describedby={open ? tooltipId : undefined}
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setOpen(false)}
        onKeyDown={(e) => {
          if (e.key === "Escape" && open) {
            e.stopPropagation();
            setOpen(false);
          }
        }}
      >
        <img src="/img/new-icons/question-circle.svg" alt="" />
      </button>
      {open && (
        <span
          id={tooltipId}
          role="tooltip"
          className="create-class-modal-hint-tooltip"
        >
          {message}
        </span>
      )}
    </span>
  );
};

export default HintTooltip;
